import { Component, OnInit, ViewChild } from '@angular/core';

import { HubService } from '../services/hub.service';
import { AppComponent } from '../app.component';
import { StandardResponse } from '../types/standard-response';
import { Installation, uploadFailure } from '../types/installation';
import { Hub } from '../types/hub';


@Component({
  selector: 'stock-summary',
  template: `<stock-sub-menu></stock-sub-menu>
<div class="editrow">
  <button type="button" mat-raised-button (click)="selectFile.click()">Choose File</button>
    <input #selectFile type="file" (change)="onFileSelected($event)"
     required accept="*.xlsx,*.csv" hidden>
  <span class="filename">{{chosenFileName()}}</span>
  <div class="block">
  <mat-form-field>
    <mat-label>Company</mat-label>
    <mat-select id="select_company" [(ngModel)]="company">
        <mat-option value="hes0005">HES</mat-option>
        <mat-option value="hub001">Insight</mat-option>
        <mat-option value="hub">EnergyServe</mat-option>
    </mat-select>
  </mat-form-field>
  </div>
  <button mat-raised-button color="primary" id="leads_upload" (click)="upload()" [disabled]="!isValid()">Upload</button>
</div>
<h3>Statistics for this Upload</h3>
<ul>
  <li *ngFor="let item of uploadStatuses | keyvalue">
    <span class="name">{{item.key}}</span>
    <span class="count">{{item.value}}</span>
  </li>
</ul>
<h3>Failures for this Upload</h3>
<ul *ngIf="uploadFailures">
  <li *ngFor="let result of uploadFailures">
    <span class="jobid">{{result.failure.job_id}}</span>
    <span class="eircode">{{postCode(result.failure)}}</span>
    <span class="name">{{result.failure.first_name}} {{result.failure.last_name}}</span>
    <span class="status">{{result.failure.status}}</span>
    <span class="error">{{result.cause}}</span>
  </li>
</ul>
<h3>Installations Completed</h3>
<ul *ngIf="uploadSaved">
  <li *ngFor="let result of uploadSaved" (click)="openHub(result)">
    <ng-container *ngIf="result.status == 'JOB_COMPLETED'">
      <span class="jobid">{{result.job_id}}</span>
      <span class="eircode">{{postCode(result)}}</span>
      <span class="name">{{result.first_name}} {{result.last_name}}</span>
      <span class="serial">{{serialNumber(result)}}</span>
      <span class="status">{{result.status}}</span>
      <span class="date">{{result.assigned_date_time | godate}}</span>
      <span class="date">{{result.end_time | godate}}</span>
    </ng-container>
  </li>
</ul>
`,
  styles: [
    `ul { display: inline-block; margin-block-start: unset; margin-block-end: unset; padding-inline-start: unset;}`,
    `li { list-style: none; }`,
    `span { display: inline-block; padding: 0.2em 0.3em; } `,
    `li span { min-width: 1em; margin: 0 0.1em;} `,
    `.filename{ width: 20em; }`,
    `.name{ width: 12em; }`,
    `.jobid { width: 6em; }`,
    `.eircode, .serial { width: 5.2em; }`,
    `.date{ width: 12em; }`,
    `.count{ width: 4em; text-align: right; }`,
    `.status{ width: 12em; }`,
    `.error{ color: #e04040; }`,
    `.block{ display: inline-block; margin-right: 20px;}`,
  ],
  providers: [HubService],
})



export class InstallUploadComponent implements OnInit {
  errorMessage: string;
  uploadFailures: uploadFailure[];
  uploadSaved: Installation[];
  theChosenOne: File;
  uploadStatuses: any[];
  company: string;
  serialNumber = InstallUploadComponent.serialNumber; // Used from HTML
  postCode = InstallUploadComponent.postCode; // Used from HTML

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('Hub Mail: ' + err);
    }
  }

  static serialNumber(result: Installation): number {
    if (result.serial_no) { return result.serial_no; }
    let scanned = +result.scan_serial_number_of_hub;
    if (Hub.ValidSerial(scanned)) {
      return scanned;
    }
    let entered = +result.entered_serial_number_of_hub;
    if (Hub.ValidSerial(entered)) {
      return entered;
    }
    let possible = (scanned ? scanned : entered);
    if (possible < 100) {
      console.log(`No serial no from entered: '${result.entered_serial_number_of_hub}' or scanned: '${result.scan_serial_number_of_hub}'`);
      return -1;
    } else if (possible > 10000000) {
      possible = Math.trunc(possible / 10);
    } else if (possible > 100000) {
      possible *= 10;
    } else if (possible > 10000) {
      possible *= 100;
    } else if (possible < 10000) {
      return Hub.HubIDToSerial(possible);
    }
    possible -= 1000000;
    return Hub.HubIDToSerial(Math.trunc(possible / 100));
  }

  static formatPostcode(inP: string): string {
    const matcher = /^([AC-FHKNPRTV-Y]\d{2}|D6W)[0-9AC-FHKNPRTV-Y]{4}$/.compile();
    if (inP && matcher.test(inP)) {
      return inP.slice(0, 3) + ' ' + inP.slice(3);
    }
    return inP;
  }

  static postCode(result: Installation): string {
    if (result.post_code) { return InstallUploadComponent.formatPostcode(result.post_code); }
    let postcode = result.eircode;
    if (!postcode) {
      postcode = result.job_postal_code;
    }
    if (postcode) {
      try {
        postcode = postcode.toUpperCase();
      } catch (e) {
        console.log(e);
      }
      try {
        postcode = postcode.replace(/[^A-Z0-9]/i, '');
      } catch (e) {
        console.log(e);
      }
    }
    return InstallUploadComponent.formatPostcode(postcode);
  }

  constructor(
    private hubService: HubService,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
  }

  onFileSelected(event: any) {
    console.log('OnFileSelected');
    this.theChosenOne = event.target.files[0];
    console.log(this.theChosenOne);
  }

  chosenFileName(): string {
    let filename = '';
    if (this.theChosenOne) {
      filename = this.theChosenOne.name;
    }
    return filename;
  }

  isValid(): boolean {
    return !!this.theChosenOne;
  }

  openHub(result: Installation): void {
    if (result.serial_no > 1000000) {
      let hubid = Hub.SerialToHubID(result.serial_no);
      window.open(`/hub/${hubid}`, `Hub ${hubid}`);
    } else {
      this.errorMessage = `Can only open Hub page to valid serial number`;
    }
  }

  upload() {
    console.log('upload....');
    this.hubService.uploadInstallationFile(this.theChosenOne, this.company)
      .subscribe(
        (data: StandardResponse) => this.uploadCompleted(data),
        error => console.log(error),
      );
  }

  uploadCompleted(data: StandardResponse): void {
    console.log('upload completed ...');
    this.uploadFailures = data.data['failures'];
    if (this.uploadFailures.length > 1) {
      console.log(JSON.stringify(this.uploadFailures[0], null, 2));
    }
    this.uploadSaved = data.data['saved'];
    this.uploadStatuses = [];
    for (let i = 0; i < this.uploadSaved.length; i++) {
      if (this.uploadStatuses[this.uploadSaved[i].status]) {
        this.uploadStatuses[this.uploadSaved[i].status]++;
      } else {
        this.uploadStatuses[this.uploadSaved[i].status] = 1;
      }
    }
  }
}

